import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';

const Root = styled(Horizontal)`
  background-color: var(--c-red-600);
  border-radius: var(--unit);
  padding: var(--half-unit) var(--unit);
`;

export const SoldOut = () => (
  <Root>
    <LabelS as="span" color="var(--c-white)">
      <FormattedMessage
        id="ClubShop.Item.Label.SoldOut"
        defaultMessage="Sold Out"
      />
    </LabelS>
  </Root>
);
